import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MenuItems, ToggleDirections } from '../header/header.model';
import { NavigationEnd, Router, Scroll } from '@angular/router';

import { AuthService } from 'src/app/auth/services';
import { BaseComponent } from 'src/app/shared/components/base-component/base.component';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidebarComponent extends BaseComponent implements OnInit {
  @Input() toggleDirection: ToggleDirections = ToggleDirections.LEFT;
  @Input() showSidebar = true;
  @Input() currentActiveParentRoute!: string;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter(false);
  @Output() onCloseSidebar: EventEmitter<boolean> = new EventEmitter(false);

  // -------------------------------
  @Input() isExpanded = false;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter<boolean>();

  menuItems = MenuItems;
  toggleDirections = ToggleDirections;

  constructor(
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly authService: AuthService
  ) {
    super();
    if (this.layout.isSidebarOnly) {
      this.setActiveRoute();
      this.getCurrentUser();
    }
  }

  ngOnInit(): void {}

  onSidebarClosed(): void {
    if (this.layout.isSidebarOnly) {
      this.showSidebar = false;
    }
  }

  handleSidebarToggle = () => this.toggleSidebar.emit(!this.isExpanded);

  setActiveRoute(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentActiveParentRoute = event.url.split('/')[1];
      } else if (event instanceof Scroll) {
        this.currentActiveParentRoute = event.routerEvent.url.split('/')[1];
      }
      this.cdr.detectChanges();
    });
  }

  getCurrentUser(): void {
    if (!this.authService.currentUser) {
      this.authService
        .getCurrentUser()
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          this.currentUser = res;
          if (this.currentUser) {
            this.authService.setCurrentUser$(this.currentUser);
          }
          this.cdr.detectChanges();
        });
    }
  }

  @ViewChild('pSideBar') pSideBar!: ElementRef;
  sidebarOff(pSideBar: any) {}
}
